export const CARD_MODE = {
  NEW: 'new',
  UPDATE: 'update',
  SAVE: 'save'
};

export const DRUG_MAX_COUNT = 5;

export const ACTION_TYPE = {
  ADD_DRUG_INFO: 'addDrugInfo',
  EDIT_DRUG_INFO: 'editDrugInfo',
  UPDATE_DRUG_INFO: 'updateDrugInfo',
  DELETE_DRUG_INFO: 'deleteDrugInfo',
  SELECT_TAG: 'select_tag',
  ADD_TAG: 'addTag',
  REMOVE_TAG: 'removeTag'
};

export const TAG_KEY_MAP = {
  symptom: {
    show: 'showSymptomTags',
    custom: 'customSymptomTags',
    error: 'showSymptomError'
  },
  diagnose: {
    show: 'showDiagnoseTags',
    custom: 'customDiagnoseTags',
    error: 'showDiagnoseError'
  }
};
